import { Button, Chip, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { ENTRY_TYPE_DRAFT } from '../../config/staticValues';
import Kpi from '../action-panel/Kpi';
import { useDispatch } from 'react-redux';
import { retractTimecard, submitTimecard } from '../../redux/timecard';
import { formatHours } from '../../util/helperFunctions';

const styles = makeStyles((theme) => ({
  label: {
    textAlign: 'right',
  },
  value: {
    textAlign: 'right',
  },
  valueText: {
    width: 60,
  },
}));

const TimecardReview = ({ timecard }) => {
  const classes = styles();
  const dispatch = useDispatch();
  const handleSubmitClick = () => {
    const existsDrafts = !!timecard.entries.find(
      (entry) => entry.type === ENTRY_TYPE_DRAFT
    );
    if (existsDrafts)
      dispatch(
        setMessage("You can't submit your timecard if you still have drafts", 'error')
      );
    else dispatch(submitTimecard(timecard.timecardId));
  };
  const handleRetractClick = () => {
    dispatch(retractTimecard(timecard.timecardId));
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Kpi />
      </Grid>
      <Grid item xs={12}>
        <Grid container style={{ width: '100%' }}>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <Typography variant="h6">Timecard summary</Typography>
          </Grid>
          <Grid item xs={6} className={classes.label}>
            <Typography>Worked hours:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.value}>
            <Typography className={classes.valueText}>
              {formatHours(timecard?.totals?.worked)}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.label}>
            <Typography>Billed hours:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.value}>
            <Typography className={classes.valueText}>
              {formatHours(timecard?.totals?.billed)}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.label}>
            <Typography>No charge hours:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.value}>
            <Typography className={classes.valueText}>
              {formatHours(timecard?.totals?.nocharge)}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.label}>
            <Typography>Vacation hours:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.value}>
            <Typography className={classes.valueText}>
              {formatHours(timecard?.totals?.vacation)}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.label}>
            <Typography>Holiday hours:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.value}>
            <Typography className={classes.valueText}>
              {formatHours(timecard?.totals?.holiday)}
            </Typography>
          </Grid>
          <Grid item xs={6} className={classes.label}>
            <Typography>Sick hours:</Typography>
          </Grid>
          <Grid item xs={6} className={classes.value}>
            <Typography className={classes.valueText}>
              {formatHours(timecard?.totals?.sick)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} style={{ textAlign: 'center', marginTop: 20 }}>
        {timecard.status === 'DRAFT' && (
          <Button variant="contained" color="primary" onClick={handleSubmitClick}>
            <Typography>Submit</Typography>
          </Button>
        )}
        {timecard.status === 'SUBMITTED' && (
          <Button variant="contained" color="primary" onClick={handleRetractClick}>
            <Typography>Retract</Typography>
          </Button>
        )}
        {timecard.status != 'SUBMITTED' && timecard.status != 'SUBMITTED' && (
          <Chip label={timecard.status} />
        )}
      </Grid>
    </Grid>
  );
};
export default TimecardReview;
